module.exports = __webpack_public_path__ + "img/collection-memoireRingsSignature.ecc3ca7.webp";